module.exports = __webpack_public_path__ + "img/ls.b815cd30.jpg";